<template>
    <div>
        <img
            class="absolute m-4 p-3"
            src="/ressources/public/img/IconSvgLogoSellsyText.svg"
            width="154"
        />

        <div class="flex-column hp-10 ai-center jc-center mt-4">
            <img src="/ressources/public/img/error/error404.svg" class="wp-3 h-auto mb-4" />
            <h2 class="gray-100">{{ title }}</h2>
            <p v-if="message.length" class="gray-60 mb-0">{{ message }}</p>
            <CompassButton
                :label="buttonOptions.label"
                type="primary"
                size="large"
                class="mt-5"
                @click="goTo"
            />
        </div>
    </div>
</template>

<script>
import { goToUrl } from '../../helpers';
export default {
    props: {
        title: {
            type: String,
            required: false,
            default: window.i18n.__('Oups, il semble que quelque chose ne va pas...'),
        },
        message: {
            type: String,
            required: false,
            default: window.i18n.__('Il arrive parfois de s’égarer et ce n’est pas bien grave'),
        },
        buttonOptions: {
            type: Object,
            required: false,
            default: () => {
                return {
                    label: window.i18n.__('Revenir à la page précédente'),
                    url: null,
                };
            },
        },
    },
    methods: {
        goToUrl,
        goTo() {
            if (this.buttonOptions.url) {
                this.goToUrl(this.buttonOptions.url);
            } else {
                history.back();
            }
        },
    },
};
</script>
<style lang="scss" scoped>
img {
    max-width: 560px;
}
h2 {
    font-size: 32px;
    font-weight: 600;
}
p {
    font-size: 20px;
    font-weight: 400;
}
</style>
